import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { environment } from '../../../../../src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class OurSponsorsService {
    
    private API_URL= environment.API_URL;

    constructor(
        private http : HttpClient
    ) {}

    getClientsLogo() {
        const url = `${this.API_URL}/afrotech-solutions-clients?populate=logo`;
        return this.http.get<any>(url, {
          headers: { Authorization: `Bearer ${environment.API_TOKEN}` }
        }).pipe(
          map((res: any) => {
            const allLogos = res.data.map((item: any) => item.attributes.logo?.data?.attributes?.url);
            const uniqueLogos = [...new Set(allLogos)]; // Supprimer les doublons
            return uniqueLogos.filter(Boolean); // Supprimer les valeurs nulles ou undefined
          })
        );
      }
      
    
}